
//var serviceName = 'verificationService'
var path = 'api/Portal/'
//var isDebug = false

function birthVerification (http, dto) {
    //loggingService.log(isDebug, serviceName, 'getCurrentPortalUser')
    return http.post(path + 'BirthVerification', dto)
}

function deathVerification (http, dto) {
    //loggingService.log(isDebug, serviceName, 'getCurrentPortalUser')
    return http.post(path + 'DeathVerification', dto)
}

function deathInsuranceVerification (http, dto) {
    return http.post(path + 'DeathInsuranceVerification', dto)
}

function marriageVerification (http, dto) {
    //loggingService.log(isDebug, serviceName, 'getCurrentPortalUser')
    return http.post(path + 'MarriageVerification', dto)
}

function divorceVerification (http, dto) {
    //loggingService.log(isDebug, serviceName, 'getCurrentPortalUser')
    return http.post(path + 'DivorceVerification', dto)
}

function emptyVerification (http, modType) {
    return http.post(path + 'EmptyVerification', modType)
}

function verificationPrint (http, id) {
    return http.post(path + 'VerificationPrint?requestId=' + id, { requestId: id }, { responseType: 'arraybuffer' })
}

function verificationRequestAbstract (http, id) {
    return http.post(path + 'VerificationRequestAbstract?requestId=' + id, { requestId: id })
}

function verificationRequestPatAff (http, id) {
    return http.post(path + 'VerificationRequestPatAff?requestId=' + id, { requestId: id })
}

export default {
    birthVerification: birthVerification,
    deathVerification: deathVerification,
    deathInsuranceVerification: deathInsuranceVerification,
    marriageVerification: marriageVerification,
    divorceVerification: divorceVerification,
    verificationPrint: verificationPrint,
    verificationRequestAbstract: verificationRequestAbstract,
    verificationRequestPatAff: verificationRequestPatAff,
    emptyVerification: emptyVerification
}
